import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAuth } from "../firebase";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../components/Dashboard.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/productos',
    name: 'productos',
    component: () => import('../components/Productos.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/ventas',
    name: 'ventas',
    component: () => import('../components/Ventas.vue'),
    meta: { requireAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const ruteProtect = to.matched.some(record => record.meta.requireAuth);
  const user = getAuth().currentUser;

  if (ruteProtect === true && user === null) {
    next({name: 'home'})
  } else {
    next()
  }
})

export default router
